function mmFlavorsSelector() {
  var splideElem = document.querySelector(".splide-flavors-selector");
  if (splideElem) {
    var splide = new Splide(splideElem, {
		type: "slide",
		pagination: false,
		arrows: true,
    autoWidth: true,
    gap: 8,
	});
    splide.mount();
  }
}

function mmSlideProductReassurance() {
	var splideElemMain = document.querySelector("#slider-reassurance");
	// SLIDER PRODUCT
	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "loop",
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
      perPage: 1,
      gap: 2,
		});
		main.mount();
	}
}

document.addEventListener("DOMContentLoaded", () => {
    mmFlavorsSelector();
    mmSlideProductReassurance();
});


// STICKY CTA DISPLAY ONLY WHEN SCROLL AFTER TRUE CTA
if (window.innerWidth < 900) {
  var derniere_position_de_scroll_connue = 0;
  var ticking = false;
  var CTA = document.querySelector(".mm-main-product-sticky-container");
  var CTA_position = CTA.offsetTop - window.screen.height / 3;

  function faireQuelqueChose(position_scroll) {
      if (position_scroll > CTA_position) {
          CTA.classList.add("mm-cta-sticky");
      } else {
          CTA.classList.remove("mm-cta-sticky");
      }
  }

  window.addEventListener("scroll", function (e) {

    derniere_position_de_scroll_connue = window.scrollY;
    if (!ticking) {
        window.requestAnimationFrame(function () {
            faireQuelqueChose(derniere_position_de_scroll_connue);
            ticking = false;
        });
    }

    ticking = true;

  });
}

class VariantSelector extends HTMLElement {
    constructor() {
        super();
        this.cached = {};
        this.container = this.closest("#product-form");
        this.addEventListener("change", this.onVariantChange);
    }

    onVariantChange() {
        this.getSelectedOptions();
        this.getSelectedVariant();

        if (this.currentVariant) {
          this.variantFetch();
            this.updateURL();
        }
    }

    getSelectedOptions() {
        this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
    }

    getVariantJSON() {
        this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    getSelectedVariant() {
        this.currentVariant = this.getVariantJSON().find((variant) => {
            const findings = !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);

            if (findings) return variant;
        });
    }

    updateURL() {
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    variantFetch() {
        var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

        if (this.cached[variantUrl]) {
            this.renderVariantInfo(this.cached[variantUrl]);
            return;
        }

        fetch(variantUrl)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                this.cached[variantUrl] = html;
                this.renderVariantInfo(html);
            })
            .catch((e) => {
                console.error(e);
            });
    }

    renderVariantInfo(html) {
      this.updateElementOuter("#mmProductFormSelectedVariantId", html);
      this.updateElementOuter(".mm-main-product-button-container", html);
      this.updateElementOuter("#mm-main-price-container", html);
      if (window.innerWidth < 900) {
        this.updateElementOuter(".mm-info-variant-sticky-container", html);
      }
    }

    /**
     *
     * @param {string} selector
     * @param {HtmlElement} html
     */
    updateElement(selector, html) {
        const destination = this.container.querySelector(selector);
        const source = html.querySelector(selector);
        if (source && destination) destination.innerHTML = source.innerHTML;
    }

    updateElementOuter(selector, html) {
        const destination = this.container.querySelector(selector);
        const source = html.querySelector(selector);
        if (source && destination) destination.outerHTML = source.outerHTML;
    }
}
customElements.define("variant-selector", VariantSelector);

/* Truncate Description */
function mmToggleDescr() {
	let trunDescriptions = document.querySelectorAll(".mm-truncate-descr");
	trunDescriptions.forEach(function (descr) {
		descr.classList.toggle("mm-none");
	});
}


function mmChangeQtty(delta, inputId) {
	var input = document.getElementById(inputId);
	if (delta == "-1" && input.value == "1") {
	} else {
    var newValue = parseInt(input.value, 10) + parseInt(delta, 10);
    input.value = newValue;
	  mmUpdatePrice(newValue);
	}
}

function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll(".mm-product-price-all");
	priceAll.forEach(function (price) {
		price.innerHTML = ((price.dataset.value * qtty) / 100).toFixed(2) + "€";
	});
}

// Ouverture des dropdowns
var acc = document.getElementsByClassName("mm-product-form-dropdown");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener('click', function () {
    // arrow rotation
    this.classList.toggle('active');
    // changement de svg (+/-)
    var icons = this.querySelectorAll(".mm-pf-dropdown-icon");
    icons.forEach(icon => {
        icon.classList.toggle('mm-none');
    })

    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });
}

// FIX JUDGE.ME ANCHOR POSITION
const jdgmPreviewBadgeLink = document.querySelectorAll('.judgme-fixed-anchor-link');
if (jdgmPreviewBadgeLink) {
    jdgmPreviewBadgeLink.forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            if (window.matchMedia("(max-width: 900px)").matches && !element.classList.contains('sticky')) {
                var avisSectionPosition = document.querySelector('.mm-avis-section').offsetTop - document.querySelector('.mm-announce-bar').offsetHeight - document.querySelector('.mm-header').offsetHeight - 60;
            } else {
                var avisSectionPosition = document.querySelector('.mm-avis-section').offsetTop - document.querySelector('.mm-announce-bar').offsetHeight - document.querySelector('.mm-header').offsetHeight;
            }
            window.scrollTo({
                top: avisSectionPosition,
                left: 0,
                behavior: "smooth",
            });
        });
    });
}
